import script from "./FAQitem_prp_home.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQitem_prp_home.vue?vue&type=script&setup=true&lang=js"

import "./FAQitem_prp_home.vue?vue&type=style&index=0&id=e49dde9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e49dde9c"]])

export default __exports__